module.exports = __webpack_public_path__ + "static/img/suo.19af50c8.png";